import { request } from "./request.js";

export async function get(key) {
    return await request("/history", { key: key }, "POST");
}

export async function save(data) {
    return await request("/history/save", data, "POST");
}

export async function list(all = false) {
    const append = all === true ? '?all' : '';
    return await request("/history/list" + append, {}, "POST");
}

export async function checkupSave(data) {
    return await request("/checkup/history", data, "POST");
}
